import './vendor';
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')
require('../../node_modules/@cmyee/pushy/js/pushy.js')






$('.slider').slick({
	dots: true,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	prevArrow: "<button class='btn-slider btn-slider--prev'><svg><use xlink:href='assets/build/images/sprites.svg#arrow-left'></use></svg></button>",
	nextArrow: "<button class='btn-slider btn-slider--next'><svg><use xlink:href='assets/build/images/sprites.svg#arrow-right'></use></svg></button>",
	autoplay: true,
  	autoplaySpeed: 2000,
	// prevArrow: $("#company-slider-prev"),
	// nextArrow: $("#company-slider-next")
});

$('.project-slider').slick({
	dots: true,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
  	autoplaySpeed: 2000,
	prevArrow: "<button class='btn-slider btn-slider--prev'><svg><use xlink:href='assets/build/images/sprites.svg#arrow-left'></use></svg></button>",
	nextArrow: "<button class='btn-slider btn-slider--next'><svg><use xlink:href='assets/build/images/sprites.svg#arrow-right'></use></svg></button>"
	// prevArrow: $("#company-slider-prev"),
	// nextArrow: $("#company-slider-next")
});


$('.projects-slider').slick({
	dots: false,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: true,
	prevArrow: $("#project-prev"),
	nextArrow: $("#project-next"),
	autoplay: true,
  	autoplaySpeed: 2000,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				variableWidth: false,
		    }
		}
	]
});



$('.doc-slider').slick({
	dots: true,
	speed: 1000,
	infinite: true,
	slidesToShow: 4,
	slidesToScroll: 4,
	prevArrow: "<button class='btn-slider btn-slider--prev'><svg><use xlink:href='assets/build/images/sprites.svg#arrow-left'></use></svg></button>",
	nextArrow: "<button class='btn-slider btn-slider--next'><svg><use xlink:href='assets/build/images/sprites.svg#arrow-right'></use></svg></button>",
	// prevArrow: $("#company-slider-prev"),
	// nextArrow: $("#company-slider-next"),
	autoplay: true,
  	autoplaySpeed: 2000,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false
		    }
		}
	]
});


$('.popup').magnificPopup({
	type: 'image',
	closeOnContentClick: true,
	closeBtnInside: false,
	fixedContentPos: true,
	mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
	image: {
		verticalFit: true
	},
	zoom: {
		enabled: true,
		duration: 300 // don't foget to change the duration also in CSS
	}
});

/*Magnific модальное окно */
$('.popup-with-form').magnificPopup({
	type: 'inline',
	preloader: false,
	focus: '#name',
	mainClass: 'mfp-fade',
	callbacks: {
		beforeOpen: function() {
			if($(window).width() < 700) {
				this.st.focus = false;
			} else {
				this.st.focus = '#name';
			}
		}
	}
});

//E-mail Ajax Send
//Documentation & Example: https://github.com/agragregra/uniMail
$(".form").submit(function() { //Change
	var th = $(this);
	$.ajax({
		type: "POST",
		url: "assets/build/mail.php", //Change
		data: th.serialize()
	}).done(function() {
		$(".done-w").fadeIn();
		setTimeout(function() {
			// Done Functions
			$(".done-w").fadeOut();
			$.magnificPopup.close();
			th.trigger("reset");
		}, 3000);
	});
	return false;
});


$('.popup-gallery').magnificPopup({
	delegate: 'a',
	type: 'image',
	tLoading: 'Загрузка изображения #%curr%...',
	mainClass: 'mfp-fade mfp-img-mobile',
	gallery: {
		enabled: true,
		navigateByImgClick: true,
		preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	},
	image: {
		tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
		titleSrc: function(item) {
			return '';
		}
	}
});



$(".tabs-block__item").not(":first").hide();
$(".tabs-block .tabs-block__tab").click(function() {
	$(".tabs-block .tabs-block__tab").removeClass("active").eq($(this).index()).addClass("active");
	$(".tabs-block__item").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("active");



$(".scroll").on("click","a", function (event) {
    // исключаем стандартную реакцию браузера
    event.preventDefault();

    // получем идентификатор блока из атрибута href
    var id  = $(this).attr('data-scroll-to'),

    // находим высоту, на которой расположен блок
        top = $(id).offset().top;

    // анимируем переход к блоку, время: 800 мс
    $('body,html').animate({scrollTop: top}, 800);
});


/*Magnific галерея*/
$('.popup-gallery').magnificPopup({
	delegate: 'a',
	type: 'image',
	tLoading: 'Загрузка изображения #%curr%...',
	mainClass: 'mfp-fade mfp-img-mobile',
	gallery: {
		enabled: true,
		navigateByImgClick: true,
		preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	},
	image: {
		tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
		titleSrc: function(item) {
			return '';
		}
	}
});
